import { Injectable } from '@angular/core';
import { FollowService } from '@app/services/api/follow.service';
import {
  ShowroomPageActionTypes,
  // LoadShowroom,
  LoadShowroomSuccess,
  LoadShowroomFail
} from '../actions/showroom.actions';

import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ShowroomEffects {
  @Effect()
  loadShowroom$: Observable<Action> = this.actions$.pipe(
    ofType(ShowroomPageActionTypes.LoadShowroom),
    switchMap(action =>
      this.followApi.getShowroomDepartments(action).pipe(
        map((departments: any[]) => new LoadShowroomSuccess(departments)),
        catchError(error => of(new LoadShowroomFail(error)))
      )
    )
  );

  constructor(private actions$: Actions, private followApi: FollowService) {}
}
